import { configureStore } from "@reduxjs/toolkit";
import { createLogger } from "redux-logger";
import userDetailsReducer from "./reducers/user-reducer";
import OrderDeatailReducer from "./reducers/trackOrder-reducer";
import MemberDetailReducer from "./reducers/member-detail-reducer";
import ComplaintDeatailReducer from "./reducers/complain.data";
import SupportDetailReducer from "./reducers/get-support";
import AdminDeatailReducer from "./reducers/admin-reducer";

const logger = createLogger();

const store = configureStore({
  reducer: {
    userDetails: userDetailsReducer,
    orderDetails: OrderDeatailReducer,
    memberDetails: MemberDetailReducer,
    complaintDetails: ComplaintDeatailReducer,
    supportDetails: SupportDetailReducer,
    adminDetails: AdminDeatailReducer,
  },
  middleware: (getDefaultMiddleware) =>
    process.env.NODE_ENV === "development"
      ? getDefaultMiddleware().concat(logger)
      : getDefaultMiddleware(),
  devTools: process.env.NODE_ENV === "development",
});

export default store;
